<template>
    <div style="min-width: 200px" class="py-2">
        <div class="mb-2">
            <nuxt-link
                :id="`shop-name--viewProduct-${createPartNumberToSlug(
                    item.pn
                )}`"
                :to="createProductLink(item)"
                no-prefetch
                class="shop-name--viewProduct shop-viewProduct"
            >
                {{ $i18n.locale === 'es' ? item.name_es : item.name_en }}
            </nuxt-link>
        </div>
        <div v-if="item.pkgqty > 1">
            <span
                class="dollars"
                style="font-size: 0.75rem"
                :title="
                    localize('orderMustBeInMultiplesOf', [
                        {
                            var: `${item.pkgqty}`,
                        },
                    ])
                "
                >
                <TranslatableStringComponent :tstring="{string: 'minQty1Units', variables: [
                        {
                            var: `${item.pkgqty}`,
                        },
                    ]}" />
            </span>
        </div>
        <div v-if="item.tariff">
            <span class="dollars" style="font-size: 0.75rem"
                >{{ item.pkgqty > 1 ? ' | ' : ''
                }}<TranslatableStringComponent :tstring="{string: 'tariffApplies'}" /></span
            >
        </div>
        <div v-if="isExemptFromShipping || hasLeadTime10Days">
            <strong
                v-if="isExemptFromShipping"
                style="color: #0063a6"
                class="mb-0"
            >
                <span class="dollars" style="font-size: 0.75rem">
                    <fa :icon="['fal', 'info-circle']" class="fa-md"
                /></span>
                <span
                    class="dollars"
                    style="font-size: 0.75rem; text-transform: uppercase"
                    ><TranslatableStringComponent :tstring="{string: 'itemExemptFromFreeShipping'}" />
                </span>
            </strong>
            <br v-if="isExemptFromShipping && hasLeadTime10Days" />
            <strong
                v-if="hasLeadTime10Days"
                style="color: #0063a6"
                class="mb-0"
            >
                <span class="dollars" style="font-size: 0.75rem">
                    <fa :icon="['fal', 'info-circle']" class="fa-md"
                /></span>
                <span
                    class="dollars"
                    style="font-size: 0.75rem; text-transform: uppercase"
                    ><TranslatableStringComponent :tstring="{string: 'itemHasLeadTime10Days'}" />
                </span>
            </strong>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
import { interpolateDOLStartersSlug } from '~/util/dol-staters-helper'

export default {
    name: 'ColumnDescription',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return {}
    },
    props: {
        item: {
            type: Object,
            default: null,
        },
    },
    methods: {
        createPartNumberToSlug(pn) {
            return pn.replace('/', '_')
        },
        createProductLink(item) {
            if (item.parent) {
                const path = this.localePath({
                    name: 'products-slug',
                    params: {
                        slug: interpolateDOLStartersSlug(item.parent[this.$i18n.locale].current),
                    },
                })
                if (this.isCustomProduct) {
                    return `${path}/${item.pn}/?isCustom=${this.isCustomProduct.hash}`
                } else {
                    return `${path}/${item.pn}/`
                }
            } else {
                return ''
            }
        },
        handleClipboard() {
            navigator.clipboard.writeText(this.item.pn)
            this.hitSnackbar({ string: 'partNumberCopiedSuccessfully' }, null)
        },
    },
    computed: {
        ...mapState('customProducts', ['customProductList']),
        ...mapState('common', ['siteSettings']),
        isCustomProduct() {
            return (
                this.customProductList.length > 0 &&
                this.customProductList.find((i) => {
                    return i.hash === this.item.hash
                })
            )
        },
        isExemptFromShipping() {
            if (
                this.siteSettings &&
                this.siteSettings.cartItemRules.length > 0
            ) {
                const isFound = this.siteSettings.cartItemRules.find((i) => {
                    if (i.pn && i.pn.includes('*')) {
                        const regEx = new RegExp(`^${i.pn.replace('*', '')}`)
                        return (
                            regEx.test(this.item.pn) && i.exemptFromFreeShipping
                        )
                    } else if (i.pn) {
                        return i.pn === this.item.pn && i.exemptFromFreeShipping
                    } else {
                        return false
                    }
                })
                return !!isFound
            } else {
                return false
            }
        },
        hasLeadTime10Days() {
            if (
                this.siteSettings &&
                this.siteSettings.cartItemRules.length > 0
            ) {
                const isFound = this.siteSettings.cartItemRules.find((i) => {
                    if (i.pn && i.pn.includes('*')) {
                        const regEx = new RegExp(`^${i.pn.replace('*', '')}`)
                        return regEx.test(this.item.pn) && i.leadTime10Days
                    } else if (i.pn) {
                        return i.pn === this.item.pn && i.leadTime10Days
                    } else {
                        return false
                    }
                })
                return !!isFound
            } else {
                return false
            }
        },
    },
}
</script>

<style></style>
